export default __webpack_public_path__ + "static/media/foxit.8e426e28.svg";